// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nsw-header {
  align-items: center;
}

.nsw-header-titles {
  flex: 1 1 auto;
  min-width: 12rem;
}

.nsw-header-titles h1 {
  margin: 0;
}

.nsw-header-sub {
  margin: 2px 0 0;
  font-size: 0.85rem;
  color: #64748b;
}

.app-shell-dark .nsw-header-sub {
  color: #94a3b8;
}

.nsw-region-link {
  display: inline-flex;
  align-items: center;
  padding: 4px 0;
  border-radius: 0;
  background: transparent;
  color: #1f4e79;
  text-decoration: none;
  font-size: 0.8rem;
  font-weight: 600;
  flex-shrink: 0;
}

.nsw-region-link:hover {
  background: transparent;
  color: #163a5a;
  text-decoration: underline;
}

.app-shell-dark .nsw-region-link {
  background: transparent;
  color: #8ec5e8;
}

.app-shell-dark .nsw-region-link:hover {
  background: transparent;
  color: #c5e1f5;
}

.nsw-map-search {
  position: absolute;
  z-index: 500;
  top: 12px;
  left: 12px;
  right: 12px;
  display: flex;
  gap: 8px;
  align-items: center;
  max-width: 420px;
  pointer-events: none;
}

.nsw-map-search input {
  pointer-events: auto;
  flex: 1 1;
  min-width: 0;
  border-radius: 2px;
  border: 1px solid #cbd5e1;
  padding: 8px 10px;
  font-size: 0.9rem;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
}

.app-shell-dark .nsw-map-search input {
  background: rgba(26, 29, 35, 0.95);
  border-color: #475569;
  color: #f1f5f9;
}

.nsw-map-count {
  pointer-events: none;
  font-size: 0.75rem;
  font-weight: 600;
  color: #334155;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 2px;
  padding: 4px 8px;
  white-space: nowrap;
}

.app-shell-dark .nsw-map-count {
  color: #e2e8f0;
  background: rgba(26, 29, 35, 0.92);
}

.nsw-meta-line {
  margin: 0 0 8px;
  font-size: 0.8rem;
  color: #64748b;
  line-height: 1.35;
}

.app-shell-dark .nsw-meta-line {
  color: #94a3b8;
}

.nsw-filter-label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0 0 10px;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #64748b;
}

.nsw-filter-label select {
  font-size: 0.85rem;
  font-weight: 500;
  text-transform: none;
  letter-spacing: normal;
  border-radius: 2px;
  border: 1px solid #cbd5e1;
  padding: 6px 8px;
  background: #fff;
  color: inherit;
}

.app-shell-dark .nsw-filter-label select {
  background: #1a1d23;
  border-color: #475569;
  color: #f1f5f9;
}

.nsw-check {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: 0 0 8px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
}

.nsw-check-inline {
  display: inline-flex;
  margin-right: 8px;
  margin-bottom: 6px;
}

.nsw-selected-box {
  margin-top: 12px;
  padding: 10px;
  border-radius: 2px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  font-size: 0.85rem;
}

.app-shell-dark .nsw-selected-box {
  background: #1a1d23;
  border-color: #334155;
}

.nsw-selected-title {
  font-weight: 700;
  margin-bottom: 2px;
}

.nsw-selected-meta {
  margin-top: 4px;
  font-size: 0.78rem;
  color: #64748b;
}

.app-shell-dark .nsw-selected-meta {
  color: #94a3b8;
}

.nsw-source-note {
  font-size: 0.75rem;
  color: #64748b;
  line-height: 1.4;
}

.app-shell-dark .nsw-source-note {
  color: #94a3b8;
}

.nsw-tabs {
  display: flex;
  gap: 6px;
  margin: 0 0 12px;
}

.nsw-tab {
  border: 1px solid #cbd5e1;
  background: #fff;
  border-radius: 2px;
  padding: 5px 10px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  color: inherit;
}

.nsw-tab-active {
  border-color: #3b82f6;
  background: #eff6ff;
  color: #1d4ed8;
}

.app-shell-dark .nsw-tab {
  background: #1a1d23;
  border-color: #475569;
}

.app-shell-dark .nsw-tab-active {
  background: #1e3a5f;
  border-color: #60a5fa;
  color: #93c5fd;
}

.nsw-tab-panel {
  min-height: 120px;
}

.nsw-error-banner {
  margin: 16px;
  padding: 16px;
  border-radius: 2px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #991b1b;
}

.hourly-day-toggles {
  margin: 0 0 10px;
}

.site-info {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  padding: 14px 16px 20px;
  border-radius: 2px;
  background: #fff;
  border: 1px solid #e2e8f0;
}

.site-info-dark {
  background: #1a1d23;
  border-color: #334155;
}

.site-info-header h2 {
  margin: 0 0 4px;
  font-size: 1.15rem;
}

.site-info-error {
  color: #dc2626;
}

.site-info-sub {
  margin: 2px 0 0;
  font-size: 0.85rem;
  color: #64748b;
}

.app-shell-dark .site-info-sub {
  color: #94a3b8;
}

.site-info-empty {
  flex: 1 1;
  padding: 16px;
  border-radius: 2px;
  background: #fff;
  border: 1px solid #e2e8f0;
}

.app-shell-dark .site-info-empty {
  background: #1a1d23;
  border-color: #334155;
}

.site-info-empty h2 {
  margin-top: 0;
}
`, "",{"version":3,"sources":["webpack://./src/nsw/NswTrafficPage.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".nsw-header {\n  align-items: center;\n}\n\n.nsw-header-titles {\n  flex: 1 1 auto;\n  min-width: 12rem;\n}\n\n.nsw-header-titles h1 {\n  margin: 0;\n}\n\n.nsw-header-sub {\n  margin: 2px 0 0;\n  font-size: 0.85rem;\n  color: #64748b;\n}\n\n.app-shell-dark .nsw-header-sub {\n  color: #94a3b8;\n}\n\n.nsw-region-link {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 0;\n  border-radius: 0;\n  background: transparent;\n  color: #1f4e79;\n  text-decoration: none;\n  font-size: 0.8rem;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.nsw-region-link:hover {\n  background: transparent;\n  color: #163a5a;\n  text-decoration: underline;\n}\n\n.app-shell-dark .nsw-region-link {\n  background: transparent;\n  color: #8ec5e8;\n}\n\n.app-shell-dark .nsw-region-link:hover {\n  background: transparent;\n  color: #c5e1f5;\n}\n\n.nsw-map-search {\n  position: absolute;\n  z-index: 500;\n  top: 12px;\n  left: 12px;\n  right: 12px;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  max-width: 420px;\n  pointer-events: none;\n}\n\n.nsw-map-search input {\n  pointer-events: auto;\n  flex: 1;\n  min-width: 0;\n  border-radius: 2px;\n  border: 1px solid #cbd5e1;\n  padding: 8px 10px;\n  font-size: 0.9rem;\n  background: rgba(255, 255, 255, 0.95);\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);\n}\n\n.app-shell-dark .nsw-map-search input {\n  background: rgba(26, 29, 35, 0.95);\n  border-color: #475569;\n  color: #f1f5f9;\n}\n\n.nsw-map-count {\n  pointer-events: none;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #334155;\n  background: rgba(255, 255, 255, 0.92);\n  border-radius: 2px;\n  padding: 4px 8px;\n  white-space: nowrap;\n}\n\n.app-shell-dark .nsw-map-count {\n  color: #e2e8f0;\n  background: rgba(26, 29, 35, 0.92);\n}\n\n.nsw-meta-line {\n  margin: 0 0 8px;\n  font-size: 0.8rem;\n  color: #64748b;\n  line-height: 1.35;\n}\n\n.app-shell-dark .nsw-meta-line {\n  color: #94a3b8;\n}\n\n.nsw-filter-label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin: 0 0 10px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  color: #64748b;\n}\n\n.nsw-filter-label select {\n  font-size: 0.85rem;\n  font-weight: 500;\n  text-transform: none;\n  letter-spacing: normal;\n  border-radius: 2px;\n  border: 1px solid #cbd5e1;\n  padding: 6px 8px;\n  background: #fff;\n  color: inherit;\n}\n\n.app-shell-dark .nsw-filter-label select {\n  background: #1a1d23;\n  border-color: #475569;\n  color: #f1f5f9;\n}\n\n.nsw-check {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin: 0 0 8px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.nsw-check-inline {\n  display: inline-flex;\n  margin-right: 8px;\n  margin-bottom: 6px;\n}\n\n.nsw-selected-box {\n  margin-top: 12px;\n  padding: 10px;\n  border-radius: 2px;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  font-size: 0.85rem;\n}\n\n.app-shell-dark .nsw-selected-box {\n  background: #1a1d23;\n  border-color: #334155;\n}\n\n.nsw-selected-title {\n  font-weight: 700;\n  margin-bottom: 2px;\n}\n\n.nsw-selected-meta {\n  margin-top: 4px;\n  font-size: 0.78rem;\n  color: #64748b;\n}\n\n.app-shell-dark .nsw-selected-meta {\n  color: #94a3b8;\n}\n\n.nsw-source-note {\n  font-size: 0.75rem;\n  color: #64748b;\n  line-height: 1.4;\n}\n\n.app-shell-dark .nsw-source-note {\n  color: #94a3b8;\n}\n\n.nsw-tabs {\n  display: flex;\n  gap: 6px;\n  margin: 0 0 12px;\n}\n\n.nsw-tab {\n  border: 1px solid #cbd5e1;\n  background: #fff;\n  border-radius: 2px;\n  padding: 5px 10px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  color: inherit;\n}\n\n.nsw-tab-active {\n  border-color: #3b82f6;\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n\n.app-shell-dark .nsw-tab {\n  background: #1a1d23;\n  border-color: #475569;\n}\n\n.app-shell-dark .nsw-tab-active {\n  background: #1e3a5f;\n  border-color: #60a5fa;\n  color: #93c5fd;\n}\n\n.nsw-tab-panel {\n  min-height: 120px;\n}\n\n.nsw-error-banner {\n  margin: 16px;\n  padding: 16px;\n  border-radius: 2px;\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  color: #991b1b;\n}\n\n.hourly-day-toggles {\n  margin: 0 0 10px;\n}\n\n.site-info {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  padding: 14px 16px 20px;\n  border-radius: 2px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n}\n\n.site-info-dark {\n  background: #1a1d23;\n  border-color: #334155;\n}\n\n.site-info-header h2 {\n  margin: 0 0 4px;\n  font-size: 1.15rem;\n}\n\n.site-info-error {\n  color: #dc2626;\n}\n\n.site-info-sub {\n  margin: 2px 0 0;\n  font-size: 0.85rem;\n  color: #64748b;\n}\n\n.app-shell-dark .site-info-sub {\n  color: #94a3b8;\n}\n\n.site-info-empty {\n  flex: 1;\n  padding: 16px;\n  border-radius: 2px;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n}\n\n.app-shell-dark .site-info-empty {\n  background: #1a1d23;\n  border-color: #334155;\n}\n\n.site-info-empty h2 {\n  margin-top: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
